<div *ngIf="genModel">
  <form class="dynamic-form" [formGroup]="form">
    <div class="container-fluid" *ngIf="!isEdit">
      <div class="row">
        <div *ngFor="let field of genModel" [class]="align ? 'col-4 customMargin32' : 'col-2 customMargin32'">
          <ng-container *ngIf="field.type === 15 && displayDate(field.name)">
            <div>
              <label class="label-font" [id]="field.name">{{ field.displayName }}</label>
            </div>
            <div class="label-strong">
              <span [id]="field.name">{{ getDate(field.value) }}</span>
            </div>
            <span class="space"></span>
          </ng-container>
          <ng-container *ngIf="field.type === 16">
            <div>
              <label class="label-font" [id]="field.name">{{ field.displayName }}</label>
            </div>
            <div class="label-strong">
              <span [id]="field.name" *ngFor="let chip of chips; let i = index"
                >{{ chip.value }}
                <span *ngIf="i < chips.length - 1">,</span>
              </span>
            </div>
            <span class="space"></span>
          </ng-container>
          <ng-container *ngIf="field.type === 13">
            <div class="dashedBox">
              <img
                src="assets/images/card-avatar.png"
                alt="avatarimg"
                *ngIf="!imgURL"
                style="width: 100%; height: 100%"
              />
              <img
                [src]="imgURL"
                *ngIf="imgURL"
                style="width: 100%; height: 100%; object-fit: cover; object-position: top center"
                alt="image"
              />
            </div>
            <span class="space"></span>
          </ng-container>

          <ng-container *ngIf="field.type === 5">
            <mat-checkbox [disabled]="!isEdit" class="custom-check" [formControlName]="field.name"
              ><label
                class="label-font nopadB"
                style="margin-bottom: 0px !important"
                [id]="field?.name"
                class="custom-label"
                >{{ field.displayName }}</label
              ></mat-checkbox
            >
          </ng-container>

          <ng-container *ngIf="field.type === 12">
            <div class="custom-radio-group">
              <mat-radio-group [formControlName]="field.name">
                <label
                  class="label-font nopadB"
                  style="margin-bottom: 0px !important"
                  [id]="field?.name"
                  class="custom-label"
                  >{{ field.displayName }}</label
                ><br />
                <mat-radio-button
                  style="margin-right: 8px"
                  [disabled]="!isEdit"
                  value="Y"
                  [checked]="bgvChecked === 'Y'"
                  >Yes</mat-radio-button
                >
                <mat-radio-button [disabled]="!isEdit" value="N" [checked]="bgvChecked === 'N'">No</mat-radio-button>
              </mat-radio-group>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              field.type !== 15 &&
              field.type !== 16 &&
              field.type !== 13 &&
              field.type !== 100 &&
              field.type !== 5 &&
              field.type !== 50 &&
              field.type !== 12
            "
          >
            <div>
              <label
                class="label-font"
                [id]="field.name"
                *ngIf="
                  field.name !== 'documentId' && field.type != 33 && !(field.name === 'addressProofType' && !proof)
                "
                >{{ field.displayName }}</label
              >
              <label
                class="label-font"
                [id]="field.name"
                *ngIf="field.name === 'documentId' && dispDocId && field.value"
                >{{ field.displayName }}</label
              >
              <label class="label-font nopadB" [id]="field?.name" class="custom-label" *ngIf="field.type == 33"
                >File Name</label
              >
            </div>
            <div class="label-strong">
              <span
                [id]="field.name"
                *ngIf="field.name !== 'panNumber' && field.name !== 'attachmentBrowse'"
                style="overflow-wrap: break-word"
              >
                {{ field.value }}
              </span>
              <span
                [id]="field.name"
                *ngIf="field.name === 'attachmentBrowse'"
                style="cursor: pointer"
                (click)="downLoadFileData(field.url)"
              >
                {{ field.value }}
              </span>
              <span
                [id]="field.name"
                *ngIf="field.name === 'addressProofType' && proof"
                style="overflow-wrap: break-word"
              >
                {{ field.options[0].value }}</span
              >

              <span
                [id]="field.name"
                *ngIf="field.name === 'panNumber' && field.value"
                style="overflow-wrap: break-word"
              >
                XXXXXX{{ field.value | slice: field.value.length - 4 : field.value.length }}
              </span>
            </div>
            <span class="space"></span>
          </ng-container>
          <ng-container *ngIf="field.type == 50">
            <div>
              <label class="label-font" [id]="field.name">
                <span *ngIf="field.name === 'attachmentBrowse'">File Name</span>
                <span *ngIf="field.name !== 'attachmentBrowse'">{{ field.displayName }}</span>
                <mat-icon matTooltip="Uploaded Through Digilocker">
                  <img alt="icon-verified" src="assets/images/icon_color_success.png" />
                </mat-icon>
              </label>
            </div>
            <div class="label-strong">
              <span [id]="field.name" *ngIf="field.name !== 'panNumber'" style="overflow-wrap: break-word">
                {{ field.value }}
              </span>
              <span
                [id]="field.name"
                *ngIf="field.name === 'panNumber' && field.value"
                style="overflow-wrap: break-word"
              >
                XXXXXX{{ field.value | slice: field.value.length - 4 : field.value.length }}
              </span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="container-fluid" *ngIf="isEdit">
      <div class="row">
        <div
          *ngFor="let field of genModel"
          [ngClass]="field.type == 33 && !addrProof ? 'col-5 customMargin32' : 'col-4 customMargin32'"
        >
          <ng-container *ngIf="field">
            <label
              class="label-font nopadB"
              [id]="field?.name"
              class="custom-label"
              *ngIf="
                field.name !== 'photograph' &&
                field.type != 100 &&
                field.type != 5 &&
                displayDate(field.name) &&
                field.type != 33 &&
                ((proof && field.name === 'addressProofType') || field.name !== 'addressProofType') &&
                field.type != 50 &&
                (field.name !== 'documentId' || (field.name === 'documentId' && dispDocId))
              "
              >{{ field.displayName }}</label
            >

            <label class="label-font nopadB" [id]="field?.name" class="custom-label" *ngIf="field.type == 33"
              >File Name</label
            >

            <label class="label-font nopadB" [id]="field?.name" class="custom-label" *ngIf="field.type == 50">
              <span *ngIf="field.name === 'attachmentBrowse'">File Name</span>
              <span *ngIf="field.name !== 'attachmentBrowse'">{{ field.displayName }}</span>
              <mat-icon matTooltip="Uploaded Through Digilocker">
                <img alt="icon-verified" src="assets/images/icon_color_success.png" />
              </mat-icon>
            </label>

            <div class="label-strong">
              <ng-container [ngSwitch]="field.type">
                <ng-template [ngSwitchCase]="14">
                  <div class="label-strong">
                    <span [id]="field.name" *ngIf="field.name !== 'panNumber'">
                      {{ field.value }}
                    </span>
                    <span [id]="field.name" *ngIf="field.name === 'panNumber' && field.value">
                      XXXXXX{{ field.value | slice: field.value.length - 4 : field.value.length }}
                    </span>
                  </div>
                  <span class="space"></span>
                </ng-template>
                <ng-template [ngSwitchCase]="0">
                  <mat-form-field *ngIf="field.name !== 'documentId'" class="example-full-width customFormField nopadB">
                    <input
                      (keypress)="omit_special_char($event, field.name)"
                      name="fieldname"
                      matInput
                      formControlName="{{ field.name }}"
                      [value]="field.value"
                      id="field?.name"
                      [placeholder]="field.placeHolder"
                    />
                    <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
                      <mat-error *ngIf="form.get(field.name).hasError(validation.name)">
                        {{ validation.message }}</mat-error
                      >
                    </ng-container>
                  </mat-form-field>
                  <mat-form-field
                    *ngIf="dispDocId && field.name === 'documentId'"
                    class="example-full-width customFormField nopadB"
                  >
                    <input
                      required
                      (keypress)="omit_special_char($event, field.name)"
                      name="fieldname"
                      matInput
                      formControlName="{{ field.name }}"
                      [value]="field.value"
                      id="field?.name"
                      [placeholder]="field.placeHolder"
                    />
                    <mat-error *ngIf="form.get(field.name).hasError('required')"> This field is required. </mat-error>
                    <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
                      <mat-error *ngIf="form.get(field.name).hasError(validation.name)">
                        {{ validation.message }}</mat-error
                      >
                    </ng-container>
                  </mat-form-field>
                </ng-template>
                <ng-template [ngSwitchCase]="15" *ngIf="displayDate(field.name)">
                  <mat-form-field class="example-full-width customFormField nopadB">
                    <input
                      matInput
                      name="field"
                      [matDatepicker]="picker"
                      [formControlName]="field.name"
                      [name]="field.name"
                      [min]="checkDate(field.name, 'min')"
                      [max]="checkDate(field.name, 'max')"
                      (dateChange)="dateSet(field.name)"
                      [(ngModel)]="field.value"
                      (click)="picker.open()"
                      readonly
                    />

                    <mat-datepicker-toggle matSuffix [for]="picker">
                      <mat-icon matDatepickerToggleIcon>
                        <img alt="icon-calendar" src="assets/images/icons/default_icons/icon-calendar.png" />
                      </mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker [startAt]="startDate"></mat-datepicker>
                    <mat-hint></mat-hint>
                    <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
                      <mat-error *ngIf="form.get(field.name).hasError(validation.name)">
                        {{ validation.message }}</mat-error
                      >
                    </ng-container>
                  </mat-form-field>
                </ng-template>
                <ng-template [ngSwitchCase]="11">
                  <div
                    class="form-group"
                    *ngIf="(proof && field.name === 'addressProofType') || field.name !== 'addressProofType'"
                  >
                    <mat-form-field
                      [ngClass]="
                        field.name === 'addressProofType' || (field.name === 'attachmentType' && addrProof)
                          ? 'customAttachFormField'
                          : 'customFormField'
                      "
                    >
                      <mat-select
                        name="options"
                        class="mySelect"
                        [(value)]="field.value"
                        [formControlName]="field.name"
                        (selectionChange)="changeSelect($event, field)"
                      >
                        <mat-option
                          *ngFor="let options of field.options"
                          [value]="options.value"
                          (onSelectionChange)="onchange(options.key, options.value, field.name)"
                        >
                          <span [matTooltip]="setValueInTooltip(options.value)">{{ options.value }}</span>
                        </mat-option>
                      </mat-select>
                      <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
                        <mat-error *ngIf="form.get(field.name).hasError(validation.name)">
                          {{ validation.message }}</mat-error
                        >
                      </ng-container>
                    </mat-form-field>
                  </div>
                </ng-template>
                <ng-template [ngSwitchCase]="22">
                  <mat-form-field class="customFormField">
                    <input
                      name="text"
                      (keypress)="omit_special_char($event)"
                      type="text"
                      aria-label="autocomplete"
                      matInput
                      [formControlName]="field.name"
                      [matAutocomplete]="auto"
                      [name]="field.name"
                    />
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option
                        *ngFor="let item of filteredOptions"
                        [id]="item.value"
                        [value]="item.value"
                        (onSelectionChange)="onchange(item.key)"
                      >
                        <span [matTooltip]="setValueInTooltip(item.value)">{{ item.value }}</span>
                      </mat-option>
                    </mat-autocomplete>
                    <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
                      <mat-error *ngIf="form.get(field.name).hasError(validation.name)">
                        {{ validation.message }}</mat-error
                      >
                    </ng-container>
                  </mat-form-field>
                </ng-template>
                <ng-template [ngSwitchCase]="16">
                  <mat-form-field class="customFormField">
                    <mat-chip-grid #chipList aria-label="Chips selection" [disabled]="form.get(field.name)?.disabled">
                      <mat-chip-row *ngFor="let chip of chips" [removable]="removable" (removed)="remove(chip)">
                        {{ chip.value }}
                        <mat-icon matChipRemove *ngIf="removable" (click)="remove(chip)">cancel</mat-icon>
                      </mat-chip-row>
                      <input
                        (ngModelChange)="onTypegetSkill($event)"
                        #chipInput
                        (keypress)="omit_special_char($event)"
                        [formControl]="chipCtrl"
                        [matAutocomplete]="auto"
                        [matChipInputFor]="chipList"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="addOnBlur"
                        [name]="field.name"
                        (matChipInputTokenEnd)="addAutoComplete($event)"
                      />
                    </mat-chip-grid>
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                      <mat-option *ngFor="let chip of filteredChips" [id]="chip.key" [value]="chip.value">
                        <span [matTooltip]="setValueInTooltip(chip.value)">{{ chip.value }}</span>
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
                    <mat-error
                      *ngIf="form.get(field.name).hasError(validation.name)"
                      style="font-size: 12px !important"
                    >
                      {{ validation.message }}</mat-error
                    >
                  </ng-container>
                </ng-template>
                <ng-template [ngSwitchCase]="10">
                  <mat-form-field class="customFormField">
                    <input
                      name="text"
                      (keypress)="omit_special_char($event)"
                      type="text"
                      aria-label="autocomplete"
                      matInput
                      [formControlName]="field.name"
                      [matAutocomplete]="auto"
                      [name]="field.name"
                      (blur)="reserFilterOptions($event)"
                    />
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option
                        *ngFor="let item of filteredOptions"
                        [id]="item.value"
                        [value]="item.value"
                        (onSelectionChange)="onchange(item.key, item.value, field.name)"
                      >
                        <span [matTooltip]="setValueInTooltip(item.value)">{{ item.value }}</span>
                      </mat-option>
                    </mat-autocomplete>
                    <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
                      <mat-error *ngIf="form.get(field.name).hasError(validation.name)">
                        {{ validation.message }}
                      </mat-error>
                    </ng-container>
                  </mat-form-field>
                </ng-template>

                <ng-template [ngSwitchCase]="13">
                  <div class="customFormField">
                    <div class="dashedBox">
                      <img
                        src="assets/images/card-avatar.png"
                        alt="avatarimg"
                        *ngIf="!imgURL"
                        style="width: 100%; height: 100%"
                      />
                      <img
                        [src]="imgURL"
                        *ngIf="imgURL"
                        style="width: 100%; height: 100%; object-fit: cover; object-position: top center"
                        alt="image"
                      />
                      <input #file type="file" accept="image/*" (change)="preview(file.files)" hidden />
                      <a (click)="file.click()">
                        <img
                          style="float: right; position: relative; top: -52px; cursor: pointer"
                          src="assets/images/icons/default_icons/icon-edit.png"
                          alt="edit icon"
                        />
                      </a>
                    </div>
                    <mat-error *ngIf="profileImgmessage" style="font-size: 12px !important">
                      {{ profileImgmessage }}
                    </mat-error>
                    <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
                      <mat-error *ngIf="form.get(field.name).hasError(validation.name)">
                        {{ validation.message }}
                      </mat-error>
                    </ng-container>
                  </div>
                </ng-template>

                <ng-template [ngSwitchCase]="5">
                  <mat-checkbox
                    class="custom-check"
                    [formControlName]="field.name"
                    (change)="checkboxChange($event, field.name)"
                    ><label
                      class="label-font nopadB"
                      style="margin-bottom: 0px !important"
                      [id]="field?.name"
                      class="custom-label"
                      >{{ field.displayName }}</label
                    ></mat-checkbox
                  >
                  <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
                    <mat-error *ngIf="form.get(field.name).hasError(validation.name)">
                      {{ validation.message }}
                    </mat-error>
                  </ng-container>
                </ng-template>

                <ng-template [ngSwitchCase]="12">
                  <div class="custom-radio-group" required>
                    <mat-radio-group [formControlName]="field.name">
                      <mat-radio-button [disabled]="!isEdit" value="Y" [checked]="field.value === 'Y'"
                        >Yes</mat-radio-button
                      >
                      <mat-radio-button [disabled]="!isEdit" value="N" [checked]="field.value === 'N'"
                        >No</mat-radio-button
                      >
                    </mat-radio-group>
                  </div>
                  <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
                    <mat-error class="custom-error" *ngIf="form.get(field.name).hasError(validation.name)">
                      {{ validation.message }}
                    </mat-error>
                  </ng-container>
                </ng-template>

                <ng-template [ngSwitchCase]="33">
                  <mat-form-field class="customFormField" [ngClass]="addrProof ? 'browseBtnAdp' : 'browseBtn'">
                    <input
                      style="cursor: pointer"
                      matInput
                      [formControlName]="field.name"
                      readonly
                      (click)="downLoadFileData(field.url)"
                    />
                  </mat-form-field>
                  <input
                    hidden
                    accept="allowedFileTypes"
                    type="file"
                    (change)="onAttachmentSelected($event)"
                    #attachfile
                  />
                  <button
                    mat-flat-button
                    *ngIf="field.value == null"
                    class="primary-btn float-right"
                    name="btnBrowse"
                    (click)="attachfile.click()"
                  >
                    Browse
                  </button>
                  <mat-error *ngIf="fileSizeError" style="font-size: 12px !important">
                    {{ fileSizeError }}
                  </mat-error>
                  <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
                    <mat-error *ngIf="form.get(field.name).hasError(validation.name)">
                      {{ validation.message }}
                    </mat-error>
                  </ng-container>
                </ng-template>
                <ng-template [ngSwitchCase]="25">
                  <div id="dynamicForm-form-div" class="phoneDiv">
                    <span class="symbolIcon" style="font-size: 1.3rem">+</span>
                    <mat-form-field
                      *ngIf="field.name === 'primaryContactNo'"
                      id="inputCOMP-form"
                      class="custom-form-field phoneCodeDiv"
                    >
                      <input
                        matInput
                        [formControlName]="countryCode.name"
                        [name]="countryCode.name"
                        [placeholder]="countryCode.displayName"
                        [type]="countryCode.inputType"
                        title="Country Code"
                        required
                      />
                      <ng-container
                        id="inputCOMP-form-ng-container"
                        *ngFor="let validation of countryCode.validations"
                        ngProjectAs="mat-error"
                      >
                        <mat-error *ngIf="form.get(countryCode.name).hasError(validation.name)">
                          {{ validation.message }}</mat-error
                        >
                      </ng-container>
                      <!-- <mat-error *ngIf="form.get(countryCode.name).hasError('required')">
                        Required</mat-error 
                      >-->
                    </mat-form-field>
                    <mat-form-field
                      *ngIf="field.name === 'alternateContactNo'"
                      id="inputCOMP-form"
                      class="custom-form-field phoneCodeDiv"
                    >
                      <input
                        matInput
                        [formControlName]="countryCode2.name"
                        [name]="countryCode2.name"
                        [placeholder]="countryCode2.displayName"
                        [type]="countryCode2.inputType"
                        title="Country Code"
                        [required]="countryCode2Required"
                      />
                      <ng-container
                        id="inputCOMP-form-ng-container"
                        *ngFor="let validation of countryCode2.validations"
                        ngProjectAs="mat-error"
                      >
                        <mat-error *ngIf="form.get(countryCode2.name).hasError(validation.name)">
                          {{ validation.message }}</mat-error
                        >
                      </ng-container>
                      <!-- <mat-error *ngIf="form.get(countryCode2.name).hasError('required')"> Required </mat-error> -->
                    </mat-form-field>
                    <mat-form-field
                      *ngIf="field.name === 'emergencyContactNo'"
                      id="inputCOMP-form"
                      class="custom-form-field phoneCodeDiv"
                    >
                      <input
                        matInput
                        [formControlName]="countryCode3.name"
                        [name]="countryCode3.name"
                        [placeholder]="countryCode3.displayName"
                        [type]="countryCode3.inputType"
                        title="Country Code"
                        [required]="countryCode3Required"
                      />
                      <ng-container
                        id="inputCOMP-form-ng-container"
                        *ngFor="let validation of countryCode3.validations"
                        ngProjectAs="mat-error"
                      >
                        <mat-error *ngIf="form.get(countryCode3.name).hasError(validation.name)">
                          {{ validation.message }}</mat-error
                        >
                      </ng-container>
                      <!-- <mat-error *ngIf="countryCode3Required"> Required </mat-error> -->
                    </mat-form-field>

                    <span class="symbolIcon" style="font-size: 2rem">-</span>
                    <mat-form-field id="inputCOMP-form" class="custom-form-field phoneNumDiv">
                      <input
                        matInput
                        [formControlName]="field.name"
                        [name]="field.name"
                        [type]="field.inputType"
                        [placeholder]="field.displayName"
                        title="Mobile(without country code and area code)"
                      />
                      <ng-container
                        id="inputCOMP-form-ng-container"
                        *ngFor="let validation of field.validations"
                        ngProjectAs="mat-error"
                      >
                        <mat-error *ngIf="form.get(field.name).hasError(validation.name)">
                          {{ validation.message }}</mat-error
                        >
                      </ng-container>
                    </mat-form-field>
                  </div>
                </ng-template>

                <ng-template [ngSwitchCase]="50">
                  <div class="label-strong">
                    <span
                      [id]="field.name"
                      *ngIf="field.name !== 'panNumber' && field.name !== 'attachmentBrowse'"
                      style="overflow-wrap: break-word"
                    >
                      {{ field.value }}
                    </span>
                    <span
                      [id]="field.name"
                      *ngIf="field.name === 'attachmentBrowse'"
                      style="overflow-wrap: break-word; cursor: pointer"
                      (click)="downLoadFileData(field.url)"
                    >
                      {{ field.value }}
                    </span>
                    <span
                      [id]="field.name"
                      *ngIf="field.name === 'panNumber' && field.value"
                      style="overflow-wrap: break-word"
                    >
                      XXXXXX{{ field.value | slice: field.value.length - 4 : field.value.length }}
                    </span>
                  </div>
                </ng-template>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </form>
</div>
